import React, { FC } from 'react'

import { Grid, withStyles, Switch, Box } from '@material-ui/core'

import T from 'components/FormattedMessage'

type Props = {
  active: 'team' | 'global'
  onChange: (value: 'team' | 'global') => void
}

const CustomSwitch = withStyles(({ spacing }) => {
  return {
    root: {
      width: 80,
      height: 37,
      padding: 3,
      margin: spacing(1),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(42px)',
        '& + $track': {
          backgroundColor: '#0000007F',
        },
      },
    },
    thumb: {
      width: 36,
      height: 36,
      backgroundColor: '#00A2FF',
      border: '2px solid #FFFFFF',
    },
    track: {
      borderRadius: 15,
      backgroundColor: '#0000007F',
    },
    checked: {},
  }
})(Switch)

const TimelineModeSwitch: FC<Props> = ({ active, onChange }) => {
  return (
    <Grid
      container
      alignItems="center"
    >
      <Grid
        item
        xs
      >
        <Box
          textAlign="center"
          color="common.white"
          fontWeight={active === 'team' ? 'fontWeightMedium' : undefined}
        >
          <T id="playerprofile_timeline_switch_in_team_title" />
        </Box>
      </Grid>
      <Grid item>
        <CustomSwitch
          checked={active === 'global'}
          onChange={ev => onChange(ev.target.checked ? 'global' : 'team')}
        />
      </Grid>
      <Grid
        item
        xs
      >
        <Box
          textAlign="center"
          color="common.white"
          fontWeight={active === 'global' ? 'fontWeightMedium' : undefined}
        >
          <T id="playerprofile_timeline_switch_on_match_title" />
        </Box>
      </Grid>
    </Grid>
  )
}

export default TimelineModeSwitch
try {
    // @ts-ignore
    TimelineModeSwitch.displayName = "TimelineModeSwitch";
    // @ts-ignore
    TimelineModeSwitch.__docgenInfo = { "description": "", "displayName": "TimelineModeSwitch", "props": { "active": { "defaultValue": null, "description": "", "name": "active", "required": true, "type": { "name": "\"team\" | \"global\"" } }, "onChange": { "defaultValue": null, "description": "", "name": "onChange", "required": true, "type": { "name": "(value: \"team\" | \"global\") => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/tabs/TimelineTab/components/TimelineModeSwitch/TimelineModeSwitch.tsx#TimelineModeSwitch"] = { docgenInfo: TimelineModeSwitch.__docgenInfo, name: "TimelineModeSwitch", path: "src/components/PlayerLayer/components/PlayerProfile/tabs/TimelineTab/components/TimelineModeSwitch/TimelineModeSwitch.tsx#TimelineModeSwitch" };
}
catch (__react_docgen_typescript_loader_error) { }